import classNames from "classnames";
import tw from "twin.macro";
import { css } from "webapp/styled-components";
import { WireButton } from "webapp/ui/views/wire-button/wire-button";
import { SectionStyleProvider } from "webapp/ui/views/wire-container/wire-container";
import { WireMenuButton } from "webapp/ui/views/wire-menu-button/wire-menu-button";
import { breakoutActions } from "webapp/wire-renderers/wire-lib";
import { isBound, UIBackgroundStyle, UIButtonAppearance, UIStyleVariant } from "wire/types";
import type { CardProps } from "./card-collection-types";

export const TableHeader: React.VFC<CardProps> = p => {
    const { desc } = p;
    const [primary, secondary, ...menuActions] = breakoutActions(desc.menuItems, 2);
    return (
        <SectionStyleProvider value={UIBackgroundStyle.Highlight}>
            <div
                className={classNames(isBound(desc.image) && "has-image")}
                css={css`
                    .${UIStyleVariant.Minimal} & {
                        ${tw`bg-transparent`}
                    }
                `}
                tw="flex px-4 bg-bg-middle bg-opacity-50 border-solid border-border-base border-b">
                {isBound(desc.image) && (
                    <div tw="w-8 mr-4">
                        <span tw="sr-only">Image</span>
                    </div>
                )}
                <div
                    css={css`
                        .${UIStyleVariant.Minimal} & {
                            ${tw`bg-transparent text-text-contextual-base`}
                        }
                    `}
                    tw="flex-1 grid grid-cols-3 gap-2 py-2 leading-tight bg-bg-middle text-xs uppercase text-text-base
                        font-semibold all-child:(overflow-hidden whitespace-nowrap overflow-ellipsis)">
                    <div
                        css={css`
                            .has-image & {
                                ${tw`-ml-12`}
                            }
                        `}>
                        {desc.title}
                    </div>
                    <div>{desc.subtitle}</div>
                    <div>{desc.emphasis}</div>
                </div>
                <div tw="flex invisible h-0 ml-4">
                    {primary !== undefined && (
                        <WireButton appearance={UIButtonAppearance.Filled}>{primary.title}</WireButton>
                    )}
                    {secondary !== undefined && (
                        <WireButton tw="not-first:ml-2" appearance={UIButtonAppearance.Bordered}>
                            {secondary.title}
                        </WireButton>
                    )}
                    {menuActions.length > 0 && (
                        <WireMenuButton
                            tw="not-first:ml-2"
                            appearance={UIButtonAppearance.Bordered}
                            menuItems={menuActions}
                        />
                    )}
                </div>
            </div>
        </SectionStyleProvider>
    );
};
